import { PERMISSIONS } from "@/permissions/constant";

export const OUTREACH_PAGE_SIZE_OPTIONS = [10, 20, 50];

export const OUTREACH_MANAGEMENT_PERMISSIONS = [PERMISSIONS.OUTREACH_VIEW, PERMISSIONS.OUTREACH_MANAGE];

export const OUTREACH_SEQUENCE_PERMISSIONS = [...OUTREACH_MANAGEMENT_PERMISSIONS, PERMISSIONS.OUTREACH_SEND];

export const OUTREACH_COMMUNICATION_PERMISSIONS = [...OUTREACH_MANAGEMENT_PERMISSIONS, PERMISSIONS.OUTREACH_SEND];
